import AgendaEditar from './AgendaEditar';

export default AgendaEditar;